import type { Components, Theme } from "@mui/material/styles";

export const MuiTextField: Components<Theme>["MuiTextField"] = {
  defaultProps: {
    variant: "outlined",
    fullWidth: true,
  },
};

export const MuiOutlinedInput: Components<Theme>["MuiOutlinedInput"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.background.paper,

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.divider,
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.light,
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
      },

      "&.Mui-error .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.error.main,
      },

      "&.sefano-success .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.success.main,
      },
    }),
    input: {
      padding: "14px 16px",
    },
    inputSizeSmall: {
      padding: "10px 14px",
    },
  },
};

export const MuiInputLabel: Components<Theme>["MuiInputLabel"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary,
      fontWeight: 600,

      "&.Mui-focused": {
        color: theme.palette.primary.main,
      },

      "&.Mui-error": {
        color: theme.palette.error.main,
      },
    }),
    shrink: ({ theme }) => ({
      color: theme.palette.primary.main,
      fontWeight: 700,
      fontSize: "0.75rem",
    }),
  },
};

export const MuiFormHelperText: Components<Theme>["MuiFormHelperText"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      marginTop: theme.spacing(0.5),
      fontWeight: 600,
    }),
  },
};
